<template>
  <div class="content">
    <div class="bannar">
      <a href="http://www.chengsmart.com"><img src="@/assets/bannar.jpg"></a> 
    </div>
    <div class="footer">
      <div class="content-text">
        <div class="text-bgc"> 请输入需要校验的数据：</div>
        <div class="centers">
               <input v-model="dataInput" class="text" />
        <button @click="calculation" class="btn">计算</button>
        </div>
      </div>
      <div class="content-text">
        <div class="text-bgc">获取后两位值结果：</div>
        <div class="centers"><input class="text" v-model="value1" type="text" /></div>
      </div>
      <div class="content-text">
        <div class="text-bgc">计算出校验值结果：</div>
        <div class="centers">
              <input class="text" v-model="value2" type="text" />
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bbc",
  data() {
    return {
      dataInput: "",
      value1: "",
      value2: "",
    };
  },
  methods: {
    calculation() {
      let data = this.dataInput.toString();
      // 获取后两位
      let len = data.length;
      this.value1 = data.slice(len - 2, len + 1).toLocaleUpperCase();

      // 获取异或结果
      let arr = data.slice(4, len - 32);
      this.value2 = this.hoxdenle(arr).toLocaleUpperCase();
    },
    hoxdenle(str) {
      console.log(str);
      var list = [];
      var ar2 = 0;
      for (var i = 0; i < str.length - 1; i += 2) {
        list.push(parseInt(str.substring(i, i + 2), 16)); //将字符串切割为两位字符的数组并转为16进制的整型。
      }
      for (var j = 0; j < list.length; j++) {
        ar2 ^= list[j]; //前两位的数组的异或结果在和第三位数组异或，以此类推得到最终结果
      }
      return parseInt(ar2).toString(16); //将得到结果进行整型，转为16进制得到最终结果
    },
  },
};
</script>

<style>
.bannar{
  width: 1920px;
  height: 500px;
  overflow: hidden;
}
.bannar a  img{
  width: 100%;
  height: 100%;
}
/* .content {
  width: 800px;
  min-height: 600px;
  margin: 0 auto;
  padding-top: 160px;
  text-align: center;
} */
.footer{
  background-color: #F08E2D;
  width: 100%;
  min-height: 600px;
  padding-left: 36%;
  padding-top: 80px;
}
.content-text{
  display: flex;
}
.text {
  display: inline-block;
  width: 300px;
  height: 38px;
  font-size: 18px;
  margin-bottom: 30px;
}
.btn {
  margin-left: 20px;
  background-color: #F57800;
  border: none;
  color: #fff;
  width: 80px;
  height: 38px;
  cursor: pointer;
}
.text-bgc{
  display: inline-block;
  background-color: #F57800;
  color: #fff;
  width: 260px;
  height: 40px;
  line-height: 40px;
  text-align: center;
}
/* .content-text {
  margin-right: 50px;
  margin-top: 20px;
} */

</style>
